import React from 'react'
import ValidationMessage from '../view/ValidationMessage'
const FormInput = ({ ...props }) => (
    <React.Fragment>
        <input
            className={`form-control ${
                props.submitted && props.errors[props.name]
                    ? "input-error"
                    : ""
                }`}
            onChange={props.handleChangeEvent}
            {...props} />
        {props.submitted && props.errors[props.name] && (
            <ValidationMessage message={props.errors[props.name]} />
        )}
    </React.Fragment>
)
export default FormInput
